module.exports = __webpack_public_path__ + "static/california_350-5966b8c0bdf471edcf1cbac7fecbbac3.webp";